<template>
    <div>
        <Topnav />
        <div class="content">
            <div class="jumbotron text-center">
                <h2>Our Pricing Plans</h2>
                <hr class="bg-dark"/>
            </div>
        <PricingTable/> 
        </div>
        <Footer/>
    </div>
</template>

<script>
import Topnav from "@/components/Topnav.vue";
import Footer from "@/components/Footer.vue";
import PricingTable from "@/components/PricingTable.vue";

export default {
    name: 'Pricing',
    components:{
        Topnav,
        Footer,
        PricingTable
    }
}
</script>